import React from 'react';

import { Stack, StackProps } from '@mui/material';

import { Body } from './Body';
import { Container } from './Container';
import { ContainerH, ContainerV } from './Container/Container';
import { Header } from './Header';

const LookoPageMenuContainer = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => (
  <Stack ref={ref} width="100%" height={'100%'} component={'main'} position={'relative'} {...props} />
));
/**
 * 페이지 스타일 메뉴 레이아웃. 헤더/바디/컨테이너로 구성.
 *
 * ```tsx
 * <LookoPageMenu>
 *   <LookoPageMenu.Header
 *     title="메뉴 제목"
 *     routes={[{ title: '상위 메뉴', to: '/parent' }]}
 *   />
 *   <LookoPageMenu.Body>
 *     <LookoPageMenu.ContainerV p={0}>
 *       <LookoPageMenu.Container.Header>섹션 제목</LookoPageMenu.Container.Header>
 *       <LookoPageMenu.ContainerH>
 *         <Typography variant="Body_Looko">콘텐츠</Typography>
 *       </LookoPageMenu.ContainerH>
 *     </LookoPageMenu.ContainerV>
 *
 *     <LookoPageMenu.ContainerV p={0}>
 *       <LookoPageMenu.Container.Link to={{ pathname: '.' }}>링크</LookoPageMenu.Container.Link>
 *     </LookoPageMenu.ContainerV>
 *   </LookoPageMenu.Body>
 * </LookoPageMenu>
 * ```
 */
export const LookoPageMenu = Object.assign(LookoPageMenuContainer, {
  /**
   * 메뉴의 헤더.
   */
  Header: Header,

  /**
   * 메뉴의 바디.
   */
  Body: Body,

  /**
   * 바디 안의 컨테이너들.
   */
  ContainerH: ContainerH,
  ContainerV: ContainerV,

  /**
   * 컨테이너 안 컨텐츠들.
   */
  Container: Container,
});
